<app-navbar-container breadcrumb="Standort">
  <app-navbar-item-large *ngIf="PermissionService.CheckPermission(PermissionService.Permissions_EventsComponent())"
                         [link]="'/' + Routes.LocationModule + '/' + LocationRoutes.Events"
                         title="Events">
    <svg class="h-6 w-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.885 18q-.877 0-1.497-.62q-.619-.618-.619-1.495q0-.877.62-1.497q.619-.619 1.496-.619t1.496.62q.619.619.619 1.496t-.62 1.496q-.618.619-1.495.619m-9.27 3q-.69 0-1.152-.462Q4 20.075 4 19.385V6.615q0-.69.463-1.152Q4.925 5 5.615 5h1.77V2.77h1.077V5h7.153V2.77h1V5h1.77q.69 0 1.152.463q.463.462.463 1.152v12.77q0 .69-.462 1.152q-.463.463-1.153.463zm0-1h12.77q.23 0 .423-.192q.192-.193.192-.423v-8.77H5v8.77q0 .23.192.423q.193.192.423.192M5 9.615h14v-3q0-.23-.192-.423Q18.615 6 18.385 6H5.615q-.23 0-.423.192Q5 6.385 5 6.615zm0 0V6z"
      />
    </svg>
  </app-navbar-item-large>
  <app-navbar-item-large *ngIf="PermissionService.CheckPermission(PermissionService.Permissions_OrderComponent())"
                         [link]="'/' + Routes.Orders"
                         title="Verkäufe">
    <svg class="h-6 w-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g class="fill-none" stroke="currentColor">
        <circle cx="5.5" cy="7.5" r="1"/>
        <path d="M8.5 6.5h11m-11 2h6" stroke-linecap="round"/>
        <circle cx="5.5" cy="12" r="1"/>
        <path d="M8.5 11h8m-8 2h7" stroke-linecap="round"/>
        <circle cx="5.5" cy="16.5" r="1"/>
        <path d="M8.5 15.5H18m-9.5 2h4" stroke-linecap="round"/>
      </g>
    </svg>
  </app-navbar-item-large>
  @if (PermissionService.CheckPermission(PermissionService.Booking_Reference_List())) {
    <app-navbar-item-small-container>
      <!--@for (type of GetTypes(BookingReferenceType); track type) {
        <app-navbar-item-small [link]="'/' + Routes.LocationModule + '/' + LocationRoutes.BookingEntityOverview"
                               [params]="{type: parseInt(type)}"
                               [title]="BookingReferenceTypeLabels[parseInt(type)]">
          <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
              fill="currentColor"/>
          </svg>
        </app-navbar-item-small>
      }-->
      <app-navbar-item-small [link]="'/' + Routes.LocationModule + '/' + LocationRoutes.BookingEntityOverview"
                             [params]="{type: BookingReferenceType.Table}"
                             title="Tische">
        <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
            fill="currentColor"/>
        </svg>
      </app-navbar-item-small>
    </app-navbar-item-small-container>
  }
  @if (PermissionService.CheckPermission(PermissionService.Permissions_LocationsComponent())) {
    <app-navbar-item-large [link]="'/' + Routes.Locations"
                           title="Verkaufspunkte">
      <svg class="h-6 w-6" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.5 7a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0M14 7c0 2.874-3.097 6.016-4.841 7.558a1.74 1.74 0 0 1-2.318 0C5.097 13.016 2 9.874 2 7a6 6 0 1 1 12 0m-1 0A5 5 0 0 0 3 7c0 1.108.615 2.395 1.57 3.683c.934 1.258 2.087 2.377 2.933 3.126a.74.74 0 0 0 .994 0c.846-.749 2-1.867 2.933-3.126C12.385 9.395 13 8.108 13 7"
        />
      </svg>
    </app-navbar-item-large>
  }
  <!-- Persistent table catalog + floor-plan areas of this shard (#201). Same audience as the table
       endpoints it drives (booking/Table/List → ShardAdmin and above). -->
  @if (PermissionService.CheckPermission(PermissionService.Permissions_TableComponent())) {
    <app-navbar-item-large [link]="'/' + Routes.LocationModule + '/' + LocationRoutes.TableLayout"
                           badge="Beta"
                           title="Tischplan">
      <svg class="bi bi-grid-1x2 h-6 w-6" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor"
              d="M6 1H1v14h5zm9 0h-5v5h5zm0 8h-5v6h5zM0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1z"/>
      </svg>
    </app-navbar-item-large>
  }
  @if (PermissionService.CheckPermission(PermissionService.Permissions_CashPointComponent())) {
    <app-navbar-item-large [link]="'/' + Routes.LocationModule + '/' + LocationRoutes.CashPoints"
                           title="Kassen">
      <svg class="h-6 w-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g class="fill-none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path
            d="M21 15h-2.5a1.503 1.503 0 0 0-1.5 1.5a1.503 1.503 0 0 0 1.5 1.5h1a1.503 1.503 0 0 1 1.5 1.5a1.503 1.503 0 0 1-1.5 1.5H17m2 0v1m0-8v1m-6 6H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2m12 3.12V9a2 2 0 0 0-2-2h-2"/>
          <path d="M16 10V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6m8 0H8m8 0h1m-9 0H7m1 4v.01M8 17v.01m4-3.02V14m0 3v.01"/>
        </g>
      </svg>
    </app-navbar-item-large>
  }
  @if (PermissionService.CheckPermission(PermissionService.Permissions_DevicesComponent())) {
    <app-navbar-item-large [link]="'/'+Routes.DeviceOverview"
                           title="Geräte">
      <svg class="bi bi-tablet h-6 w-6" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/>
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
      </svg>
    </app-navbar-item-large>
  }
  <!-- Web-managed PoS app configuration (company baseline / shard baseline / per-device overrides). Device
       management audience (ShardAdmin and above), like the Devices screen. -->
  @if (PermissionService.CheckPermission(PermissionService.Permissions_DevicesComponent())) {
    <app-navbar-item-large [link]="'/'+Routes.CompanyModule+'/'+CompanyRoutes.DeviceConfig"
                           title="Geräte-Konfiguration">
      <svg class="bi bi-sliders h-6 w-6" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
              d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"
              fill="currentColor"/>
      </svg>
    </app-navbar-item-large>
  }
  @if (PermissionService.CheckPermission(PermissionService.Permissions_PrinterComponent())) {
    <app-navbar-item-large [link]="'/' + Routes.LocationModule + '/' + LocationRoutes.Printers"
                           title="Drucker">
      <svg class="h-6 w-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 17v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2M7 17v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2M7 17H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1m0 0V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2M6 7h12m0 0h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2M7 10h1"
          fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"/>
      </svg>
    </app-navbar-item-large>
  }

  <!-- Standort "App-Konfiguration" and "Einstellungen" were retired: the PoS app configuration (default view,
       order-history visibility, card payment provider, booking-reference types) is now managed centrally under
       Unternehmen → Geräte-Konfiguration, and the SumUp affiliate key under PlatformOwner → Integrationen. -->
</app-navbar-container>
